import { GsapMarquee } from '../../ui/GsapMarquee/GsapMarquee';
import { Reveal } from '../../ui/Reveal/Reveal';
import './Clients.css';

const clients = [
  'Meridian',
  'Aria',
  'Volt',
  'House of Concord',
  'Nova',
  'Atlas Group',
  'Titans FC',
  'Solstice',
  'Helios',
  'Vesper',
];

export function Clients() {
  return (
    <section className="clients">
      <div className="container">
        <Reveal>
          <div className="clients__label">
            <span className="clients__dot" />
            <span>Trusted by 220+ studios, brands and families across 37 countries</span>
          </div>
        </Reveal>
      </div>

      <div className="clients__marquee">
        <GsapMarquee speed={45}>
          {clients.map((c, i) => (
            <span key={i} className="clients__item">
              {c}
              <span className="clients__dot-sep">·</span>
            </span>
          ))}
        </GsapMarquee>
      </div>
    </section>
  );
}
